import React from "react";
import classes from "./Layout.module.css";
import MainHeader from "../Header/MainHeader";
import MainFooter from "../Footer/MainFooter";

const Layout = (props) => {
  return (
    <>
      <MainHeader />
      <main className={classes.main}>{props.children}</main>
      <MainFooter />
    </>
  );
};

export default Layout;
